import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { SET_VEHICLE_PICKED_UP_DATE } from '../../redux/OffersDetails';
import { SET_MODAL } from '../../redux/Modal';
import icons from '../../helpers/Icons';
import PickupDateBarContainer from './PickupDateBarContainer';
import PickupDateBarContainerEasyTransport from './PickupDateBarContainerEasyTransport';
import { compose } from 'redux';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';
class PickupDateBarWrapperContainer extends PureComponent {
  state = {
    newPickupDate: '',
    hasBeenMovedToArchive: false,
    isPickedupCheckboxChecked: false,
  };

  handlePickupDateChange = (selectedDates) => {
    const selectedDate = selectedDates[0];
    const dateString = selectedDate ? moment(selectedDate).format('') : null;
    this.setState({ newPickupDate: dateString });
  };

  handleSetPickedUpDateSubmit = () => {
    const { setModal, pickupDate } = this.props;
    return new Promise((resolve) => {
      const { hashId, setVehiclePickedupDate } = this.props;
      const { newPickupDate } = this.state;

      setVehiclePickedupDate({
        hashId,
        pickedUpDate: newPickupDate || pickupDate,
        promise: { resolve },
      });
    }).then(() => {
      this.setState({ hasBeenMovedToArchive: true });
      setModal({
        componentName: 'ReceivedVehicleModal',
        customContentClass: 'received-vehicle-modal',
      });
    });
  };

  preparePickupDateLabel = (date, t) => {
    return date ? <strong>{moment(date).format('DD.MM.YYYY')}</strong> : t('no_pickup-date');
  };

  preparepickedupSubmitLabel = (t) => {
    return (
      <span>
        {icons('check')}
        {t('receipted_vehicle')}
      </span>
    );
  };

  render() {
    const { isEasyTransportEnabled, pickupDate, hashId, status, t } = this.props;
    const { newPickupDate, hasBeenMovedToArchive, isPickedupCheckboxChecked } = this.state;

    if (hasBeenMovedToArchive) return null;

    const pickupDateLabel = this.preparePickupDateLabel(pickupDate, t);
    const pickedupSubmitLabel = this.preparepickedupSubmitLabel(t);
    const datepickerPlaceholder = pickupDate ? t('change_date') : t('set_pickup_date');
    const leftSideClassNames = classNames({
      'picked-up-unset': !!pickupDate && !newPickupDate,
    });

    const pickedupCheckboxLabel = t('declaration_of_receipt');
    const sendDateToSellerLabel = t('send_date_to_seller');
    const sendLabel = t('send');
    const cancelLabel = t('cancel');

    return isEasyTransportEnabled ? (
      <PickupDateBarContainerEasyTransport
        pickupDate={pickupDate}
        hashId={hashId}
        status={status}
        handlePickupDateChange={this.handlePickupDateChange}
        handleSetPickedUpDateSubmit={this.handleSetPickedUpDateSubmit}
        newPickupDate={newPickupDate}
        hasBeenMovedToArchive={hasBeenMovedToArchive}
        pickupDateLabel={pickupDateLabel}
        pickedupSubmitLabel={pickedupSubmitLabel}
        datepickerPlaceholder={datepickerPlaceholder}
        leftSideClassNames={leftSideClassNames}
        pickedupCheckboxLabel={pickedupCheckboxLabel}
        isPickedupCheckboxChecked={isPickedupCheckboxChecked}
        sendDateToSellerLabel={sendDateToSellerLabel}
        sendLabel={sendLabel}
        cancelLabel={cancelLabel}
      />
    ) : (
        <PickupDateBarContainer
          hashId={hashId}
          pickupDate={pickupDate}
          handlePickupDateChange={this.handlePickupDateChange}
          handleSetPickedUpDateSubmit={this.handleSetPickedUpDateSubmit}
          newPickupDate={newPickupDate}
          hasBeenMovedToArchive={hasBeenMovedToArchive}
          pickupDateLabel={pickupDateLabel}
          pickedupSubmitLabel={pickedupSubmitLabel}
          datepickerPlaceholder={datepickerPlaceholder}
          leftSideClassNames={leftSideClassNames}
          pickedupCheckboxLabel={pickedupCheckboxLabel}
          isPickedupCheckboxChecked={isPickedupCheckboxChecked}
          sendDateToSellerLabel={sendDateToSellerLabel}
          sendLabel={sendLabel}
          cancelLabel={cancelLabel}
        />
      );
  }
}

PickupDateBarWrapperContainer.propTypes = {
  setVehiclePickedupDate: PropTypes.func.isRequired,
  setModal: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  isEasyTransportEnabled: PropTypes.bool.isRequired,
  pickupDate: PropTypes.string,
  hashId: PropTypes.string,
  status: PropTypes.string,
};

PickupDateBarWrapperContainer.defaultProps = {
  pickupDate: '',
  hashId: '',
  status: '',
};


const mapDispatchToProps = (dispatch) => {
  return {
    setModal: values => dispatch(SET_MODAL(values)),
    setVehiclePickedupDate: payload => dispatch(SET_VEHICLE_PICKED_UP_DATE(payload)),
  };
};

export default compose(
  connect(null, mapDispatchToProps),
  withScopedTranslations('details_date_bar'),
  )(PickupDateBarWrapperContainer);

